import React, { useRef, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Portal from 'components/Portal/Portal'
import { Modal } from '../Modal/Modal'
import { saveWizard } from '../Designer2/DesignerActions'
import { importToLast } from './FormManagerActions'
import { Checkbox } from '@tecuity/granite-ui/'
import { GET_WIZARD_EXISTS } from '../../requests'

const ImportDialog = ({
  isOpened,
  closeModal,
  closeAndReload,
  categoryTarget,
  onImport,
}) => {

  const dispatch = useDispatch()
  const modalRef = useRef(null)
  const [preserveId, setPreserveId] = React.useState(false)
  const [error, setError] = React.useState('')

  const addToCategory = useCallback(
    (formDefinitionId) => {
      dispatch(importToLast(
        {
          categoryId: categoryTarget,
          formDefinitionId: parseInt(formDefinitionId, 10),
        },
        () => {
          modalRef.current && modalRef.current.closeModal(() => {
            closeAndReload()
          })
        }
      ))
    },
    [categoryTarget, importToLast, closeAndReload]
  )

  const processUpload = useCallback(
    (e) => {
      const reader = new FileReader()

      reader.onload = () => {
        let json = JSON.parse(reader.result)

        if (onImport) {
          onImport(
            json,
            preserveId,
            categoryTarget,
            () => modalRef.current && modalRef.current.closeModal(() => closeAndReload()),
            (errorMsg) => setError(errorMsg)
          )
          return
        }

        if (preserveId) {
          GET_WIZARD_EXISTS(json.FORM_DEFINITION_ID, 
            res => { 
              res === true ? setError('FormDefinitionId already exists, form has not been imported.') : dispatch(saveWizard(json, onSuccess, onError))
            }, error => {
              setError('Error fetching Form Definitions')
            }
          )
        }
        else {
          json.FORM_DEFINITION_ID = 0
          dispatch(saveWizard(json, onSuccess, onError))
        }

        const onSuccess = (formDefinitionId) => {
          if (categoryTarget) {
            addToCategory(formDefinitionId)
          } else {
            modalRef.current && modalRef.current.closeModal(() => {
              closeAndReload()
            })
          }
        }

        const onError = (err) => {
          try {
            const error = JSON.parse(err)
            if (error.status === 400) {
              // Retry for pre-5.0 wizards
              json.STEPS_JSON = JSON.parse(json.STEPS_JSON)
              json.GLOBAL_VARIABLES = JSON.parse(json.GLOBAL_VARIABLES)
              json.WIZARD_ATTRIBUTES_LOGIC = JSON.parse(json.WIZARD_ATTRIBUTES_LOGIC)

              dispatch(saveWizard(json, onSuccess))
            }
          } catch (err) {
            // swallow parse errors, same behavior as class version
          }
        }
      }

      reader.readAsText(e.target.files[0])
    },
    [addToCategory, categoryTarget, closeAndReload, saveWizard, preserveId, onImport]
  )

  return (
    <Portal isOpened={isOpened}>
      <Modal
        ref={modalRef}
        modalSize="toast"
        title="Import Wizards"
        hideHeader
        modalBodyClassName="import-dialog"
        closeModal={closeModal}
      >
        <p>
          Select a previously-exported <b>.json</b> file.
        </p>

        <Checkbox
          label="Preserve Form ID"
          checked={preserveId}
          onChange={e => setPreserveId(e)}
        />

        <input
          type="file"
          name="json"
          id="json"
          accept="application/json"
          className="file-input"
          onChange={processUpload}
        />

        <label htmlFor="json" className="file-label btn-raised btn-primary">
          Choose a json file
        </label>

        {error && <p className='field-error' style={{textAlign: "center"}}>
          {error}
        </p>}
      </Modal>
    </Portal>
  )
}

export default ImportDialog 